import { type AvatarSize } from '#app/components/Avatars/Avatar/types.js';
import { getAvatarSize } from '#app/components/Avatars/Avatar/utils.js';
import { JobOutlineIcon } from '@contra/icons/icons';
import { css, styled, useTheme } from 'styled-components';

const LogoEmptyStateContainer = styled.div<{ size: number }>`
  ${({ size, theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.colorsV2.gray20};
    width: ${size}px;
    height: ${size}px;
    border-radius: 50%;
  `}
`;

type OrganizationLogoEmptyStateProps = {
  readonly size?: AvatarSize;
};

export const OrganizationLogoEmptyState = ({
  size = 'sm',
}: OrganizationLogoEmptyStateProps) => {
  const theme = useTheme();
  const logoSize = getAvatarSize(size);

  return (
    <LogoEmptyStateContainer size={logoSize}>
      <JobOutlineIcon
        color={theme.colorsV2.gray60}
        size={logoSize / 2}
      />
    </LogoEmptyStateContainer>
  );
};
